import React from "react";
import { Box, Heading } from "@blasterjs/core";
import styled from "styled-components";

import BalloonAnimationLong from "components/BalloonAnimationLong";

const HoverText = styled(Box)`
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  :hover {
    opacity: 1;
  }
`;

const LoadingCard = () => (
  <Box display="flex" alignItems="stretch">
    <BalloonAnimationLong width="100%" height="100%" />
    <HoverText
      position="absolute"
      top={0}
      bottom={0}
      left={0}
      right={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Heading as="h4" textAlign="center" color="white">
        Processing...
      </Heading>
    </HoverText>
  </Box>
);

export default LoadingCard;
